import { gql } from 'graphql-tag'

export const GET_DATA_HEALTH_CHECKS_QUERY = gql`
  query GET_DATA_HEALTH_CHECKS_QUERY {
    getDataHealthChecks {
      check
      type
      dimension
    }
  }
`
